import { gql } from '@apollo/client'

const DIETS_QUERY = gql`
  query diets($filters: DietFiltersInput) {
    diets(filters: $filters) {
      id
      name
      excludedIngredients {
        id
        name
      }
    }
  }
`

export default DIETS_QUERY
